/* eslint-disable max-statements */
/* eslint-disable react/no-children-prop */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable security/detect-object-injection */
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { Button } from "@nextui-org/button";
import { Tooltip } from "@nextui-org/tooltip";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { AppDispatch, RootState } from "../app/store";
import copyImg from "../assets/copySvg.svg";
// import copyiconIcon from "../assets/copy_icon.png";
// import goodResponseIcon from "../assets/good_response_icon.png";
import doubleThumbsUp from "../assets/double-thumbs-up.png";
import like_thumbs from "../assets/like_thumbs.svg";
import logo from "../assets/logo-small.png";
import newChat from "../assets/new_chat_icon.png";
import newChatLight from "../assets/new_chat_icon_light.png";
import openSidebar from "../assets/open_sidebar_icon.png";
import openSidebarLight from "../assets/open_sidebar_icon_light.png";
import sendIcon from "../assets/send_icon.png";
import sendIconLight from "../assets/send_icon_light.png";
import shareIcon from "../assets/share_chat_icon.png";
import shareIconLight from "../assets/share_chat_icon_light.png";
import thumbs_down from "../assets/thumbs_down.svg";
import userChatIcon from "../assets/user_chat_icon.png";
import { isRenderSidebar, sendMessages } from "../features/chatSlice";
import { openModal } from "../features/modalSlice";
import { toggleMinimize } from "../features/themeSlice";
import { apiService } from "../services/apiService";
import { Message, MessageContexts } from "../types/chat";
import { copyToClipboard, getCookieToken, gptModels, setCookieToken, UserData } from "../utils";
import ModalManager from "./ModalManager";
import MyMarkdownComponent from "./MyMarkdownComponent";
import ThemeSwitch from "./ThemeSwitch";
// import { getOpenAIResponse, getOpenAIResponseWithHistory } from "./getOpenAIResponse";
// import { getOpenAIResponseForFile } from "./getOpenAIResponseForFile";
import chatArrowIcon from "../assets/chat_arrow_icon.png";

interface ChatWindowProps {
  sharedData?: any;
  overlayRef?: React.MutableRefObject<HTMLDivElement | null>;
}
const ChatWindow: React.FC = ({ sharedData, overlayRef }: ChatWindowProps) => {
  const dispatch: AppDispatch = useDispatch();
  const [isMessageSent, setIsMessageSent] = useState(false);
  const [userData, setUserData] = useState<UserData | null>(null);
  const { chatID } = useParams(); // Access the dynamic 'id' from the URL, which may be undefined
  // Static messages list
  const [showScrollToBottom, setShowScrollToBottom] = useState(false);
  const [selectedModel, setSelectedModel] = useState("gpt-4o-mini");

  const navigate = useNavigate();

  const theme = useSelector((state: RootState) => state.theme.theme);
  const activeChatId = useSelector((state: RootState) => state.chat.activeChatId);
  const isMinimized = useSelector((state: RootState) => state.theme.minimize);
  // eslint-disable-next-line security/detect-object-injection
  const chatContainerRef = useRef<HTMLDivElement>(null);
  const [messages, setMessages] = useState<Message[]>([]); // Start with static messages
  const [allMessages, setAllMessages] = useState<MessageContexts[]>([]); // Start with static messages
  const [message, setMessage] = useState<string>("");
  const [loadMessages, setLoadMessages] = useState<boolean>(false);
  const textareaRef = useRef<HTMLTextAreaElement | null>(null); // Define the ref type
  const fileRef = useRef<HTMLInputElement | null>(null); // fileRef is of type HTMLInputElement | null
  const [isUserScrolling, setIsUserScrolling] = useState(false); // Track if the user is scrolling
  const currentURL = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;
  const [halfUrl] = currentURL.split("/chat/");

  useEffect(() => {
    const data = getCookieToken("user");
    setUserData(data);
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      const newHeight = Math.min(textareaRef.current.scrollHeight, 200); // Adjust height
      textareaRef.current.style.height = `${newHeight}px`;
    }
  }, [message]);
  useEffect(() => {
    if (messages.length > 0 && !isUserScrolling) {
      scrollToBottom();
    }
  }, [messages, isUserScrolling]);
  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const messagesEndRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const fetchMessages = async () => {
      try {
        setLoadMessages(true);
        const id = Number(chatID);
        const response = await apiService.getChatMessages(id); // Call the API service
        const messagesTwo = response?.data?.messages ?? []; // Safely access messages
        // console.log("at api messages >> ", messagesTwo);
        setMessages(messagesTwo); // Set the messages to state
        setLoadMessages(false);
      } catch (error) {
        toast.error("Error loading messages.", {
          className:
            "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
          duration: 2000,
        });
        setLoadMessages(false);
      }
    };

    if (chatID) {
      fetchMessages(); // Fetch messages only if activeChatId is valid
    }
  }, [chatID]);
  const [clickedButtons, setClickedButtons] = useState<Record<string, boolean>>({});

  const prevMessages = messages.map((msg) => ({
    role: msg.role === "You" ? "user" : "assistant",
    content: msg.content,
  }));

  const handleButtonClick = (buttonId: string, msgId: number) => {
    if (buttonId === "copy") {
      setClickedButtons((prev) => ({ ...prev, [msgId]: true }));

      // Revert back to the original state after 3 seconds
      setTimeout(() => {
        setClickedButtons((prev) => ({ ...prev, [msgId]: false }));
      }, 3000);
    }
  };

  const sendMessage = async () => {
    setIsMessageSent(true);
    const tempAllMessages = [...allMessages];
    const tempFiles: string[] = [];
    const tempContext: MessageContexts[] = [];
    if (message.trim()) {
      const lastSequence =
        messages.length > 0 ? Math.max(...messages.map((msg) => msg.sequence ?? 0)) : 0; // Default to 0 if no messages exist
      const userMessage: Message = {
        id: Date.now(), // Unique ID for the user message
        content: message.trim(),
        timestamp: new Date().toISOString(),
        role: "You",
      };

      // Update local state with the user message
      setMessages((prevMessages) => [...prevMessages, userMessage]);

      // console.log("chatHistory >> ", chatHistory);
      // Dispatch to update Redux store
      dispatch(sendMessages({ chatId: activeChatId, message: userMessage }));
      setMessage(""); // Clear input after sending the message

      try {
        const aiMessageId = Date.now() + 1; // Ensure AI message has a unique ID
        // const aiMessageId = messages?.length > 0 ? messages[messages?.length-1]?.id : Date.now() + 1; // Ensure AI message has a unique ID
        // const aiMessageId = messages?.length && messages[messages?.length-1]?.id  ; // Ensure AI message has a unique ID

        const placeholderMessage: Message = {
          id: aiMessageId,
          content: "",
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
          sequence: lastSequence + 1, // Increment sequence
          role: "AI",
        };

        // If chat is new, create chat and send message
        if (chatID === undefined) {
          const maxWords = 70; // Maximum number of words allowed
          const maxChars = 70; // Maximum number of characters allowed

          const words = message.trim().split(/\s+/); // Split by spaces

          // Construct title based on word and character constraints
          let title = words.length > maxWords ? words.slice(0, maxWords).join(" ") : message.trim();
          if (title.length > maxChars) {
            title = title.substring(0, maxChars).trim(); // Truncate to maxChars and remove trailing spaces
          }

          const createChatResponse = await apiService.createChat({
            user_id: userData?.sub ?? 0, // Fallback to 0 if userData?.sub is undefined
            org_id: userData?.org_id ?? 0, // Fallback to 0 if userData?.org_id is undefined
            title: title,
          });
          if (createChatResponse?.data) {
            // Using `any` to allow any structure for the response
            const createChatData: any = createChatResponse.data; // Cast to `any`
            const messageData = {
              chat_id: createChatData.id, // Access the id from the response
              user_id: createChatData.user_id, // Access user_id
              role: "You",
              content: message,
              sequence: lastSequence + 2, // AI response follows user's sequence
            };

            try {
              // Send the initial message for the newly created chat
              await apiService.sendMessage(messageData);
              // Add placeholder message for AI response
              setMessages((prevMessages) => [...prevMessages, placeholderMessage]);
              dispatch(sendMessages({ chatId: activeChatId, message: placeholderMessage }));
              const getChatResponce = await apiService
                .getChatContext({ query: message.trim(), chat_id: createChatData.id, modelName: selectedModel })
                .then(async (response) => {
                  if (response.data && typeof response.data === 'object' && "files" in response.data && Array.isArray(response.data.files)) {
                    tempFiles.push(...response.data.files);
                  }
                  if (response.data && typeof response.data === 'object' && "response" in response.data && Array.isArray(response.data.response)) {
                    tempContext.push(...response.data.response);
                    const tavilyMessage = tempContext.find((f) => f?.name === "web");
                    const tavilyMessageObj = {
                      chat_id: createChatData.id, // Access the id from the response
                      user_id: createChatData.user_id, // Access user_id
                      role: "AI",
                      content: `# **Tavily Response** : \n\n\n ${tavilyMessage?.content}`,
                      sequence: messageData?.sequence + 1, // AI response follows user's sequence
                    };
                    if (tavilyMessage?.name === "web") {
                      const tavilyResponse = await apiService.sendMessage(tavilyMessageObj) as any;
                      if (tavilyResponse && tavilyResponse?.data) {
                        setMessages((prev) => [...prev, {
                          id: tavilyResponse.data?.id,
                          content: `# **Tavily Response** : \n\n\n ${tavilyResponse.data?.content}`,
                          role: tavilyResponse.data?.role,
                          sequence: tavilyResponse.data?.sequence,
                          created_at: tavilyResponse.data?.created_at,
                          updated_at: tavilyResponse.data?.updated_at,
                        }]);
                      }
                    }
                  }
                  tempAllMessages.push({ role: "user", content: JSON.stringify(response.data) ? JSON.stringify(response.data).replace(/.*"response":"(.*)".*/, '$1') : messageData?.content });
                  return JSON.stringify(response.data);
                });
              const { answer: answerNew, source_guideline } = JSON.parse(getChatResponce);
              const aiMessageNew: Message = {
                id: aiMessageId,
                content: answerNew,
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString(),
                sequence: lastSequence + 1,
                role: "AI",
                files: source_guideline,
              };

              setMessages((prevMessages) =>
                [...prevMessages, aiMessageNew]
              );

              const aiMessageData = {
                chat_id: createChatData.id,
                user_id: userData?.sub ?? 0,
                role: "AI",
                content: answerNew,
                sequence: lastSequence + 3,
                files: source_guideline,
              };
              await apiService.sendMessage(aiMessageData);
              navigate(`/chat/${createChatData.id}`);
              dispatch(isRenderSidebar());
              setIsMessageSent(false);
            } catch (error) {
              toast.error("Error sending message:", {
                className:
                  "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
                duration: 2000,
              });
            }
          } else {
            toast.error("Failed to create chat, no valid response received.", {
              className:
                "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
              duration: 2000,
            });
          }
          setAllMessages(tempAllMessages);
        } else {
          // If not new, use the active chat ID to send the message
          const messageData = {
            chat_id: parseInt(activeChatId), // Use the active chat ID
            user_id: userData?.sub ?? 0,
            role: "You",
            content: message,
            // content: allMsg,
            sequence: lastSequence + 1, // AI response follows user's sequence
          };

          const temp = [...messages];
          // Send the initial message for the existing chat
          const response = (await apiService.sendMessage(messageData)) as any;
          // Add placeholder message for AI response
          if (response && response?.data) {
            const payload = {
              id: response.data.id,
              content: response.data.content,
              role: response.data.role,
              sequence: response.data.sequence,
              created_at: response.data.created_at,
              updated_at: response.data.updated_at,
            };

            temp.push(payload);
            setMessages(temp);
            dispatch(sendMessages({ chatId: response.data.chat_id.id, message: payload }));
          }

          // CONTEXT API
          const getChatResponce = await apiService
            .getChatContext({ query: message.trim(), chat_id: chatID, modelName: selectedModel })
            .then((response) => {
              if (
                response.data &&
                typeof response.data === "object" &&
                "files" in response.data &&
                Array.isArray(response.data.files)
              ) {
                tempFiles.push(...response.data.files);
              }
              if (
                response.data &&
                typeof response.data === "object" &&
                "response" in response.data &&
                Array.isArray(response.data.response)
              ) {
                tempContext.push(...response.data.response);
              }
              tempAllMessages.push({
                role: "user",
                content: JSON.stringify(response.data)
                  ? JSON.stringify(response.data).replace(/.*"response":"(.*)".*/, "$1")
                  : messageData?.content,
              });
              return JSON.stringify(response.data);
            });
          const { answer: answerExisting, source_guideline: sourceGuidelineExisting } =
            JSON.parse(getChatResponce);

          const aiMessageExisting: Message = {
            id: aiMessageId,
            content: answerExisting,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
            sequence: lastSequence + 1,
            role: "AI",
            files: sourceGuidelineExisting,
          };

          const aiMessageData = {
            chat_id: parseInt(activeChatId),
            user_id: userData?.sub ?? 0,
            role: "AI",
            content: answerExisting,
            sequence: lastSequence + 3,
            files: sourceGuidelineExisting,
          };

          await apiService.sendMessage(aiMessageData);
          setMessages((prevMessages) => [...prevMessages, aiMessageExisting]);
          dispatch(sendMessages({ chatId: activeChatId, message: aiMessageExisting }));
          setIsMessageSent(false);
          setAllMessages(tempAllMessages);
        }
      } catch (error) {
        toast.error("Error:", {
          className:
            "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
          duration: 2000,
        });
        setIsMessageSent(false);
      }
    }
  };

  // const handleFileUpload = async (file: File) => {
  //   setIsMessageSent(true);

  //   // Check if the file is valid
  //   if (file) {
  //     const lastSequence =
  //       messages.length > 0 ? Math.max(...messages.map((msg) => msg.sequence ?? 0)) : 0;

  //     // Create a user message to represent the file upload
  //     const userMessage: Message = {
  //       id: Date.now(),
  //       content: `Uploaded file: ${file.name}`, // You can add more info here
  //       timestamp: new Date().toISOString(),
  //       role: "You",
  //     };

  //     // Update local state with the user message
  //     setMessages((prevMessages) => [...prevMessages, userMessage]);

  //     // Dispatch to update Redux store
  //     dispatch(sendMessages({ chatId: activeChatId, message: userMessage }));

  //     try {
  //       const aiMessageId = Date.now() + 1; // Ensure AI message has a unique ID
  //       const placeholderMessage: Message = {
  //         id: aiMessageId,
  //         content: "",
  //         created_at: new Date().toISOString(),
  //         updated_at: new Date().toISOString(),
  //         sequence: lastSequence + 1, // Increment sequence
  //         role: "AI",
  //       };

  //       // Add placeholder message for AI response
  //       setMessages((prevMessages) => [...prevMessages, placeholderMessage]);
  //       dispatch(sendMessages({ chatId: activeChatId, message: placeholderMessage }));

  //       // Send the file for processing and get the AI response query: message.trim()
  //       const getChatResponce = await apiService.getChatContext({ query: `File: ${file.name}`, chat_id: chatID || "" });

  //       let aiContent = "";

  //       // Assuming getOpenAIResponseForFile is a function that streams the response
  //       const aiResponse = getOpenAIResponseForFile(file, (chunk: string) => {
  //         aiContent += chunk; // Incrementally build AI response
  //         setMessages((prevMessages) =>
  //           prevMessages.map((msg) =>
  //             msg.id === aiMessageId ? { ...msg, content: aiContent } : msg
  //           )
  //         );
  //         dispatch(
  //           updateMessageContent({
  //             chatId: activeChatId,
  //             messageId: aiMessageId,
  //             content: aiContent,
  //           })
  //         );
  //       });

  //       // Handling the promise if aiResponse is asynchronous
  //       await aiResponse;

  //       // After AI response is complete
  //       setMessages((prevMessages) => {
  //         const updatedMessages = prevMessages.map((msg) =>
  //           msg.id === aiMessageId ? { ...msg, content: aiContent } : msg
  //         );
  //         return updatedMessages;
  //       });

  //       // Send AI response message after receiving the content
  //       const aiMessageData = {
  //         chat_id: parseInt(activeChatId), // Use the active chat ID
  //         user_id: userData?.sub ?? 0,
  //         role: "AI",
  //         content: aiContent,
  //         sequence: lastSequence + 2, // AI response follows user's sequence
  //       };

  //       try {
  //         await apiService.sendMessage(aiMessageData);
  //       } catch (error) {
  //         toast.error("Error sending AI response:", {
  //           className:
  //             "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
  //           duration: 2000,
  //         });
  //       }

  //       setIsMessageSent(false);
  //     } catch (error) {
  //       toast.error("Error processing file:", {
  //         className:
  //           "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
  //         duration: 2000,
  //       });
  //       setIsMessageSent(false);
  //     }
  //   } else {
  //     console.log("No file selected");
  //   }
  // };

  const newChatPage = () => {
    navigate(`/chat`);
  };
  // Callback function to get a reference to the DotLottie component
  const copyMessage = (message: string) => {
    navigator.clipboard
      .writeText(message)
      .then(() => {
        // toast.success("Message copied to clipboard");
      })
      .catch((error) => {
        toast.error("Failed to copy message: ", {
          className:
            "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
          duration: 2000,
        });
      });
  };
  const messageResponses = [
    {
      id: "copy",
      icon: copyImg,
      alt: "Copy",
    },
    {
      id: "good",
      icon: like_thumbs,
      alt: "Good Response",
    },
    {
      id: "bad",
      icon: thumbs_down,
      alt: "Bad Response",
    },
  ];
  // Scroll to the bottom when new messages arrive (if the user isn't manually scrolling)
  const scrollToBottom = () => {
    if (chatContainerRef.current && !isUserScrolling) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };
  // Handle scroll event to detect if user is scrolling manually
  const handleScroll = () => {
    if (chatContainerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = chatContainerRef.current;
      if (scrollTop + clientHeight < scrollHeight - 50) {
        setIsUserScrolling(true); // User is scrolling up
        setShowScrollToBottom(true); // Show the scroll-to-bottom button
      } else {
        setIsUserScrolling(false); // User is at the bottom
        setShowScrollToBottom(false); // Hide the scroll-to-bottom button
      }
    }
  };
  const handleScrollToBottom = () => {
    chatContainerRef.current?.scrollTo({
      top: chatContainerRef.current.scrollHeight,
      behavior: "smooth",
    });
  };

  const SkeletonLoader = () => {
    return (
      <div className="w-full h-full space-y-6">
        {/* Skeleton for a left-aligned message */}
        <div className="flex justify-start space-x-4 animate-pulse">
          <div className="w-12 h-12 bg-[#d1d5db1a] rounded-full"></div>
          <div className="flex-1 w-full">
            <div className="h-6 bg-[#d1d5db1a] rounded-md  w-3/4 mb-3"></div>
            <div className="h-4 bg-[#d1d5db1a] rounded-md w-5/6 mb-3"></div>
            <div className="h-4 bg-[#d1d5db1a] rounded-md w-2/3 mb-3"></div>
          </div>
        </div>

        {/* Skeleton for a right-aligned message */}
        <div className="flex justify-end space-x-4 animate-pulse">
          <div className="w-12 h-12 bg-[#d1d5db1a] rounded-full mb-3"></div>
          <div className="flex-1 w-full">
            <div className="h-6 bg-[#d1d5db1a] rounded-md  w-2/3 mb-3"></div>
            <div className="h-4 bg-[#d1d5db1a] rounded-md w-1/2 mb-3"></div>
            <div className="h-4 bg-[#d1d5db1a] rounded-md w-3/4 mb-3"></div>
          </div>
        </div>

        {/* Skeleton for a left-aligned message */}
        <div className="flex justify-start space-x-4 animate-pulse">
          <div className="w-12 h-12 bg-[#d1d5db1a] rounded-full mb-3"></div>
          <div className="flex-1 w-full">
            <div className="h-6 bg-[#d1d5db1a] rounded-md  w-4/5 mb-3"></div>
            <div className="h-4 bg-[#d1d5db1a] rounded-md w-1/2 mb-3"></div>
            <div className="h-4 bg-[#d1d5db1a] rounded-md w-3/4 mb-3"></div>
          </div>
        </div>

        {/* Skeleton for a right-aligned message */}
        <div className="flex justify-end space-x-4 animate-pulse">
          <div className="w-12 h-12 bg-[#d1d5db1a] rounded-full mb-3"></div>
          <div className="flex-1 w-full">
            <div className="h-6 bg-[#d1d5db1a] rounded-md  w-2/3 mb-3"></div>
            <div className="h-4 bg-[#d1d5db1a] rounded-md w-1/2 mb-3"></div>
            <div className="h-4 bg-[#d1d5db1a] rounded-md w-3/4 mb-3"></div>
          </div>
        </div>
      </div>
    );
  };

  const TypingIndicator = () => (
    <div className="flex items-center justify-start pt-2 space-x-2">
      <div className="w-3 h-3 bg-[#d1d5db57] rounded-full animate-bounce"></div>
      <div className="w-3 h-3 bg-[#d1d5db57] rounded-full animate-bounce-dots "></div>
      <div className="w-3 h-3 bg-[#d1d5db57] rounded-full animate-bounce"></div>
    </div>
  );

  useEffect(() => {
    document.documentElement.className = theme; // Dynamically update the theme
    setCookieToken("theme", theme); // Save the theme in cookies
  }, [theme]);

  const fullText = "Hi, I am Bob.\nHow can I help you today?";
  const [displayedText, setDisplayedText] = useState("");

  useEffect(() => {
    let currentIndex = 0;

    const typeCharacter = () => {
      if (currentIndex < fullText.length) {
        setDisplayedText(fullText.slice(0, currentIndex + 1)); // Update the state with the substring
        currentIndex++;
        setTimeout(typeCharacter, 70); // Control typing speed
      }
    };

    typeCharacter();

    return () => {
      currentIndex = fullText.length; // Ensure cleanup on unmount
    };
  }, [fullText, chatID]);

  const handleGoodFeedback = (id: number) => {
    try {
      const feedbackData = {
        msg_id: id,
        user_id: userData?.sub ?? 0,
        remarks: "Excellent service",
        comments: "Detailed feedback about the chat session",
        payload: {
          rating: 5,
          tags: ["user feedback"],
        },
      };

      const response = apiService.postFeedback(feedbackData);
      // console.log("response feedback: ", response);
      toast.success("Feedback Given", {
        className:
          "md:!bg-[#00B21B]/20 !bg-[#00B21B]/100 dark:!text-white dark:text-[#191919] !shadow-none",
        duration: 2000,
      });

      // Close modal after successful feedback
    } catch (error) {
      toast.error("Error submitting feedback", {
        className:
          "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
        duration: 2000,
      });
    }
  };

  const handleOpenShareLink = () => {
    dispatch(openModal({ name: "ModalShareLink" }));
  };

  const fetchShareLink = async (e: any, new_id: number) => {
    // console.lo
    // g("new_id: ", new_id);
    try {
      const response = await apiService.shareChat(new_id); // Call the API service
      if (response?.status === 200) {
        if ((response as any)?.data?.id) {
          const id = (response as any)?.data?.id;
          const link = `${halfUrl}/share/${id}`;
          await new Promise((resolve) => setTimeout(resolve, 100));
          await copyToClipboard(link);
        }

        toast.success("Chat Link Copied to Clipboard", {
          className: "md:!bg-[#00B21B]/20 !bg-[#00B21B]/100 dark:!text-white dark:text-[#191919] !shadow-none",
          duration: 2000,
        });
      }
    } catch (error) {
      console.error("Error loading share link:", error);
      toast.error("Error loading share link.", {
        className: "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
        duration: 2000,
      });
    }
  };
  // Handle save button click
  const handleShareChat = async (e: any) => {
    try {
      const response = await apiService.postShareChat(Number(chatID));
      const respId = (response as any)?.data?.id;
      if (respId) {
        fetchShareLink(e, respId);
      }
      // Close modal after successful sharing
      // onClose();
    } catch (error) {
      toast.error("Error sharing chat", {
        className: "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
        duration: 2000,
      });
    }
  };

  const handleDoubleThumbsup = async (msgId: number) => {
    try {
      const response = await apiService.doubleThumbsUp(Number(chatID), Number(msgId));
      const success = (response as any)?.data?.status === 200;
      if (success) {
        toast.success("Added to Bob", {
          className: "md:!bg-[#00B21B]/20 !bg-[#00B21B]/100 dark:!text-white dark:text-[#191919] !shadow-none",
          duration: 2000,
        });
      }
    } catch (error) {
      toast.error("Something went wrong", {
        className: "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
        duration: 2000,
      });
    }
  };

  return (
    <div
      className={`h-full flex px-3 flex-col relative bg-chatLightBg backdrop-blur-[20px] :bg-opacity-80 dark:bg-[linear-gradient(119deg,#091B27_0%,#10324B_100%)] dark:bg-opacity-80 dark:backdrop-blur-[42px] rounded-3xl py-4 ${isMinimized ? "sm:ml-7" : "md:ml-1"} sm:mr-7`}
    >
      <div className="flex items-center w-full pb-5 md:pb-0">
        <div className={`flex items-start ${isMinimized && "pl-5"} min-w-[18rem] space-x-3 md:pl-0`}>
          {isMinimized ? (
            <>
              <Tooltip
                content="New Chat"
                // placement="bottom"
                classNames={{
                  content: [
                    "dark:bg-[#265376]/30 bg-white backdrop-blur-[23px] rounded-lg shadow-none",
                  ],
                }}
              >
                <button
                  onClick={newChatPage}
                  className="text-chatLightText dark:text-chatDarkText hover:text-gray-800 dark:hover:text-gray-300"
                >
                  <img
                    src={theme ? newChat : newChatLight}
                    alt="logo"
                    className="w-6 h-6 transition-all duration-200 ease-in-out md:mb-6 md:ml-4 dark:brightness-100 hover:opacity-40 brightness-50"
                    width={19}
                    height={19}
                  />
                </button>
              </Tooltip>
              <Tooltip
                content="Close Sidebar"
                placement="bottom"
                classNames={{
                  content: [
                    "dark:bg-[#265376]/30 bg-white backdrop-blur-[23px] rounded-lg shadow-none",
                  ],
                }}
              >
                <button
                  onClick={() => dispatch(toggleMinimize())}
                  className="text-chatLightText dark:text-chatDarkText hover:text-gray-800 dark:hover:text-gray-300"
                >
                  <img
                    src={theme ? openSidebar : openSidebarLight}
                    alt="logo"
                    className="w-6 h-6 transition-all duration-200 ease-in-out md:mb-6 md:ml-4 dark:brightness-100 hover:opacity-40 brightness-50"
                    width={19}
                    height={19}
                  />
                </button>
              </Tooltip>
            </>
          ) : null}
          <div className={`flex items-center justify-start w-full gap-2 ${isMinimized && "pl-5"}`}>
            <p className="line-clamp-1 text-ellipsis overflow-hidden block text-left dark:text-[#D1D1D1] text-[#191919]">{selectedModel}</p>
            <Menu >
              <MenuButton className="">
                <Tooltip
                  content="Select Model"
                  classNames={{
                    content: [
                      "dark:bg-[#265376]/30 bg-white backdrop-blur-[23px] rounded-lg shadow-none",
                    ],
                  }}
                >
                  <img
                    src={chatArrowIcon}
                    alt="add"
                    width={21}
                    height={21}
                    className="rotate-180 invert dark:invert-0"
                  />
                </Tooltip>
              </MenuButton>
              <MenuItems
                transition
                anchor="bottom"
                className="z-[100] w-fit origin-top-right rounded-xl border border-white/5 dark:bg-lightBg/5 bg-chatDarkBg/5 p-1 text-sm/6 text-white transition duration-100 ease-out [--anchor-gap:var(--spacing-1)] focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0"
              >
                {gptModels.map((m) => (
                  <MenuItem key={m} >
                    <button
                      type="button"
                      onClick={() => setSelectedModel(m)}
                      className="text-left group flex w-full items-center gap-2 rounded-lg py-1.5 px-3 data-[focus]:bg-white/10 dark:text-lightBg text-chatLightText"
                    >
                      {m}
                    </button>
                  </MenuItem>
                ))
                }
              </MenuItems>
            </Menu>
          </div>
        </div>
        <div className="flex items-center justify-end w-full sm:gap-5 md:gap-0">
          {chatID && (
            <Tooltip
              content="Share Chat"
              placement="top-start"
              classNames={{
                content: [
                  "dark:bg-[#265376]/30 bg-white backdrop-blur-[23px] rounded-lg shadow-none",
                ],
              }}
            >
              <button
                onClick={async (e) => {
                  e.stopPropagation();
                  handleShareChat(e);
                }}
                className="z-50 flex justify-end w-auto min-w-0 px-1 py-0 text-center text-white bg-transparent border-0 outline-none md:-mr-5 invert-0 dark:invert"
              >
                <img src={theme ? shareIconLight : shareIcon} alt="share" width={25} height={20} />
              </button>
            </Tooltip>
          )}{" "}
          <ThemeSwitch className="!mt-0" />
        </div>
      </div>

      <div
        className="flex-1 overflow-y-auto mb-4 max-w-[1366px] w-full mx-auto space-y-4 "
        onScroll={handleScroll}
        ref={chatContainerRef}
      >
        {loadMessages ? (
          // Render Skeleton Loader when loading is true
          <div className="flex flex-col items-center justify-center h-full p-4">
            <SkeletonLoader />
          </div>
        ) : (
          <>
            {messages.length > 0 && chatID ? (
              <>
                {(() => {
                  const rows = [];
                  let i = 0;

                  while (i < messages.length) {
                    const msg = messages[i] as Message;

                    const isAIMessage = (m: Message) => m.role === "AI";

                    const renderFeedbackButtons = (m: Message) => (
                      <div className="flex gap-1 mt-5">
                        {messageResponses.map((button) => (
                          <Tooltip
                            classNames={{
                              content: [
                                "dark:bg-[#265376]/30 bg-white backdrop-blur-[23px] rounded-lg shadow-none duration-0",
                              ],
                            }}
                            key={button.id}
                            content={button.alt}
                          >
                            <Button
                              onPress={() => {
                                if (button.id === "copy" && typeof m.content === "string") {
                                  copyMessage(m.content);
                                }
                                handleButtonClick(button.id, m.id);
                                if (button.id === "bad" || button.id === "good") {
                                  dispatch(
                                    openModal({
                                      name: "ModalGiveFeedback",
                                      props: {
                                        msg_id: m.id,
                                        user_id: userData?.sub,
                                        chat_id: chatID,
                                        buttonId: button.id,
                                      },
                                    })
                                  );
                                }
                              }}
                              className={`transform transition-transform duration-300 bg-transparent min-w-8 p-0 -ml-2 ${clickedButtons[m.id] && button.id === "copy" ? "scale-110" : ""}`}
                              disabled={clickedButtons[m.id] && button.id === "copy"}
                            >
                              {clickedButtons[m.id] && button.id === "copy" ? (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    fill="currentColor"
                                    fillRule="evenodd"
                                    d="M12 22c-4.714 0-7.071 0-8.536-1.465C2 19.072 2 16.714 2 12s0-7.071 1.464-8.536C4.93 2 7.286 2 12 2s7.071 0 8.535 1.464C22 4.93 22 7.286 22 12s0 7.071-1.465 8.535C19.072 22 16.714 22 12 22m2.474-13.581a.75.75 0 0 1 .107 1.055l-5.714 7a.75.75 0 0 1-1.162 0l-2.286-2.8a.75.75 0 0 1 1.162-.948l1.705 2.088l5.133-6.288a.75.75 0 0 1 1.055-.107m4 0a.75.75 0 0 1 .107 1.055l-5.714 7a.75.75 0 0 1-1.21-.064l-.285-.438a.75.75 0 0 1 .88-1.116l5.167-6.33a.75.75 0 0 1 1.055-.107"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              ) : (
                                <img
                                  src={button.icon}
                                  alt={button.alt}
                                  className={`${theme === "dark" ? "" : "filterGrey"} ${button.id === "copy" ? "w-[14.23px] h-[16.48px]" : button.id === "excellent" ? "w-[20.74px] h-[20px]" : "w-[16.74px] h-[16px]"}`}
                                />
                              )}
                            </Button>
                          </Tooltip>
                        ))}
                        <Tooltip
                          classNames={{
                            content: [
                              "dark:bg-[#265376]/30 bg-white backdrop-blur-[23px] rounded-lg shadow-none duration-0",
                            ],
                          }}
                          content={"Add to Bob"}
                        >
                          <Button
                            onPress={() => handleDoubleThumbsup(m.id)}
                            className="p-0 -ml-2 transition-transform duration-300 transform scale-110 bg-transparent min-w-8"
                          >
                            <img
                              src={doubleThumbsUp}
                              alt="Add to bob"
                              className={`${theme === "dark" ? "" : "filterGrey"} w-[20.74px] h-[20px]`}
                            />
                          </Button>
                        </Tooltip>
                      </div>
                    );

                    if (msg.role === "You") {
                      rows.push(
                        <div
                          key={msg.id}
                          className={`overflow-x-hidden flex w-full justify-end ${i === 0 ? "mt-12 md:mt-0" : ""}`}
                        >
                          <div
                            id="chat-message"
                            className={`py-0 md:px-6 px-3 rounded-[15px] max-w-full w-fit lg:text-lg md:text-base text-sm overflow-hidden bg-[#e0e0e0]/90 backdrop-blur-[20px] dark:bg-[#091B27]/80 text-chatLightText dark:text-chatDarkText`}
                          >
                            <MyMarkdownComponent
                              msg={
                                typeof msg.content === "string"
                                  ? isAIMessage(msg) && !msg.content.includes("# **Tavily Response** :")
                                    ? `# **Vellum Response** : \n\n\n ${msg.content}`
                                    : msg.content
                                  : ""
                              }
                            />
                          </div>
                          <img src={userChatIcon} alt="You" className="ml-2 rounded-full w-7 h-7" />
                        </div>
                      );
                      i++;
                    }
                    // ✅ Safely check if i+1 exists
                    else if (
                      isAIMessage(msg) &&
                      i + 1 < messages.length &&
                      isAIMessage(messages[i + 1])
                    ) {
                      const pair = [messages[i], messages[i + 1]];
                      rows.push(
                        <div key={`ai-pair-${i}`} className="flex w-full gap-4">
                          {pair.map((aiMsg) => (
                            <div key={aiMsg.id} className="flex items-start w-1/2">
                              <img
                                src={logo}
                                alt="AI"
                                className="p-1 mt-4 mr-2 bg-white rounded-full w-7 h-7"
                              />
                              <div
                                id="chat-message"
                                className="py-0 md:px-6 px-3 rounded-[15px] w-full lg:text-lg md:text-base text-sm overflow-hidden bg-transparent dark:bg-transparent text-chatLightText dark:text-chatDarkText"
                              >
                                {aiMsg.role === "AI" && !aiMsg.content && <TypingIndicator />}
                                <MyMarkdownComponent
                                  msg={
                                    typeof aiMsg.content === "string"
                                      ? isAIMessage(aiMsg) && !aiMsg.content.includes("# **Tavily Response** :")
                                        ? `# **Vellum Response** : \n\n\n ${aiMsg.content}`
                                        : aiMsg.content
                                      : ""
                                  }
                                />
                                {renderFeedbackButtons(aiMsg)}
                              </div>
                            </div>
                          ))}
                        </div>
                      );
                      i += 2;
                    } else {
                      // Single AI fallback
                      rows.push(
                        <div
                          key={msg.id}
                          className={`overflow-x-hidden flex w-full ${msg.role === "You" ? "justify-end" : ""} ${i === 0 ? "mt-12 md:mt-0" : ""}`}
                        >
                          {msg.role !== "You" && (
                            <img
                              src={logo}
                              alt={msg.role}
                              className="p-1 mt-4 mr-2 bg-white rounded-full w-7 h-7"
                            />
                          )}
                          <div
                            id="chat-message"
                            className={`py-0 md:px-6 px-3 rounded-[15px] max-w-full w-fit lg:text-lg md:text-base text-sm overflow-hidden ${msg.role === "You"
                              ? "bg-[#e0e0e0]/90 backdrop-blur-[20px] dark:bg-[#091B27]/80 text-chatLightText dark:text-chatDarkText"
                              : "bg-transparent dark:bg-transparent text-chatLightText dark:text-chatDarkText"}`}
                          >
                            {msg.role === "AI" && !msg.content && <TypingIndicator />}
                            <MyMarkdownComponent
                              msg={
                                typeof msg.content === "string"
                                  ? isAIMessage(msg) && !msg.content.includes("# **Tavily Response** :")
                                    ? `# **Vellum Response** : \n\n\n ${msg.content}`
                                    : msg.content
                                  : ""
                              }
                            />
                            {msg.files?.length ?
                              <>
                                <p className="text-base">Sources :</p>
                                <ul className="pl-6 list-disc">
                                  {msg.files.map((source, index) => (
                                    <li key={`${source}-${index}`} className="text-sm">
                                      <a
                                        rel="noopener noreferrer"
                                        href={`${source}`}
                                        target="_blank"
                                      >
                                        {source}
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              </> : null}
                            {renderFeedbackButtons(msg)}
                          </div>
                          {
                            msg.role === "You" && (
                              <img src={userChatIcon} alt="You" className="ml-2 rounded-full w-7 h-7" />
                            )
                          }
                        </div>
                      );
                      i++;
                    }
                  }
                  return rows;
                })()}
              </>
            ) : (
              <div className="flex flex-col items-center justify-center h-full p-4">
                <div className="w-full mb-12">
                  <h2 className="text-[#BFBFBF] dark:text-[#265376] text-left duration-0 text-[2.25rem] lg:text-7xl sm:text-4xl md:tracking-[-2.94px] tracking-[-0.94px] font-proximaBold md:leading-loose leading-9">
                    {displayedText.split("\n").map((line, index) =>
                      index === 0 ? (
                        <span key={index} className="font-proximaBold">
                          {line.split("I am").map((segment, subIndex) =>
                            subIndex === 1 ? (
                              <span
                                key={subIndex}
                                className="text-[#191919] dark:text-white font-proximaBold"
                              >
                                I am{segment}
                              </span>
                            ) : (
                              segment
                            )
                          )}
                        </span>
                      ) : (
                        <span key={index} className="block pt-3 font-proximaBold sm:pt-0">
                          {/* <br /> */}
                          {line}
                        </span>
                      )
                    )}
                  </h2>
                </div>

                <div className="w-full bg-white/30 brightness-[0.8] dark:brightness-90 dark:bg-black/10 rounded-2xl px-5 py-2">
                  <div className="w-full mb-4">
                    <textarea
                      ref={textareaRef}
                      value={message}
                      disabled={isMessageSent}
                      onChange={(e) => setMessage(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && !e.shiftKey && message.trim() !== "") {
                          e.preventDefault();
                          sendMessage();
                          setMessage("");
                        }
                      }}
                      placeholder="Ask me anything... "
                      rows={1}
                      className="w-full outline-none focus-visible:border-0 focus-visible:ring-0 ring-transparent outline-transparent border-transparent resize-none placeholder:brightness-125 dark:placeholder:text-[#5E829F] placeholder:text-[#7B7B7B] text-base focus:outline-none bg-transparent dark:text-white text-chatLightText rounded-lg py-1 overflow-y-auto"
                      style={{ maxHeight: "400px", overflowY: "auto" }}
                    />
                  </div>
                  {/* Button Container */}
                  <div className="flex items-center justify-end">
                    {/* <div className="flex space-x-4">
                      <Menu>
                        <MenuButton className="">
                          <Tooltip
                            content="Attach File"
                            classNames={{
                              content: [
                                "dark:bg-[#265376]/30 bg-white backdrop-blur-[23px] rounded-lg shadow-none",
                              ],
                            }}
                          >
                            <img
                              src={addIcon}
                              alt="add"
                              width={21}
                              height={21}
                              className="invert dark:invert-0"
                            />
                          </Tooltip>
                        </MenuButton>

                        <MenuItems
                          transition
                          anchor="bottom"
                          className="w-fit origin-top-right rounded-xl border border-white/5 dark:bg-lightBg/5 bg-chatDarkBg/5 p-1 text-sm/6 text-white transition duration-100 ease-out [--anchor-gap:var(--spacing-1)] focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0"
                        >
                          <MenuItem>
                            <button
                              onClick={() => {
                                // Trigger the file input click event to open file dialog
                                fileRef.current?.click();
                              }}
                              className="text-left group flex w-full items-center gap-2 rounded-lg py-1.5 px-3 data-[focus]:bg-white/10 dark:text-lightBg text-chatLightText"
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-5 h-5 shrink-0"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M18.0322 5.02393C17.7488 5.00078 17.3766 5 16.8 5H11.5002C11.3 6 11.0989 6.91141 10.8903 7.85409C10.7588 8.44955 10.6432 8.97304 10.3675 9.41399C10.1262 9.80009 9.80009 10.1262 9.41399 10.3675C8.97304 10.6432 8.44955 10.7588 7.85409 10.8903C7.81276 10.8994 7.77108 10.9086 7.72906 10.9179L5.21693 11.4762C5.1442 11.4924 5.07155 11.5001 5 11.5002V16.8C5 17.3766 5.00078 17.7488 5.02393 18.0322C5.04612 18.3038 5.0838 18.4045 5.109 18.454C5.20487 18.6422 5.35785 18.7951 5.54601 18.891C5.59546 18.9162 5.69617 18.9539 5.96784 18.9761C6.25118 18.9992 6.62345 19 7.2 19H10C10.5523 19 11 19.4477 11 20C11 20.5523 10.5523 21 10 21H7.16144C6.6343 21 6.17954 21 5.80497 20.9694C5.40963 20.9371 5.01641 20.8658 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3.13419 18.9836 3.06287 18.5904 3.03057 18.195C2.99997 17.8205 2.99998 17.3657 3 16.8385L3 11C3 8.92477 4.02755 6.93324 5.4804 5.4804C6.93324 4.02755 8.92477 3 11 3L16.8385 3C17.3657 2.99998 17.8205 2.99997 18.195 3.03057C18.5904 3.06287 18.9836 3.13419 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C20.8658 5.01641 20.9371 5.40963 20.9694 5.80497C21 6.17954 21 6.6343 21 7.16144V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V7.2C19 6.62345 18.9992 6.25118 18.9761 5.96784C18.9539 5.69617 18.9162 5.59546 18.891 5.54601C18.7951 5.35785 18.6422 5.20487 18.454 5.109C18.4045 5.0838 18.3038 5.04612 18.0322 5.02393ZM5.28014 9.41336L7.2952 8.96556C8.08861 8.78925 8.24308 8.74089 8.35381 8.67166C8.48251 8.59121 8.59121 8.48251 8.67166 8.35381C8.74089 8.24308 8.78925 8.08861 8.96556 7.2952L9.41336 5.28014C8.51014 5.59289 7.63524 6.15398 6.89461 6.89461C6.15398 7.63524 5.59289 8.51014 5.28014 9.41336ZM17 15C17 14.4477 17.4477 14 18 14C18.5523 14 19 14.4477 19 15V17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H19V21C19 21.5523 18.5523 22 18 22C17.4477 22 17 21.5523 17 21V19H15C14.4477 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17H17V15Z"
                                  fill="currentColor"
                                ></path>
                              </svg>
                              Upload from computer
                            </button>
                          </MenuItem>
                        </MenuItems>
                      </Menu>
                    </div>*/}
                    <button
                      onClick={sendMessage}
                      disabled={isMessageSent || message.trim() === ""}
                      className={`relative mb-2`}
                    >
                      {isMessageSent ? (
                        // <div className="loader-chat"></div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={38}
                          height={38}
                          viewBox="0 0 24 24"
                          className="!duration-0 transition-none brightness-150"
                        >
                          <circle cx={4} cy={12} r={3} fill="currentColor">
                            <animate
                              id="svgSpinners3DotsBounce0"
                              attributeName="cy"
                              begin="0;svgSpinners3DotsBounce1.end+0.25s"
                              calcMode="spline"
                              dur="0.6s"
                              keySplines=".33,.66,.66,1;.33,0,.66,.33"
                              values="12;6;12"
                            ></animate>
                          </circle>
                          <circle cx={12} cy={12} r={3} fill="currentColor">
                            <animate
                              attributeName="cy"
                              begin="svgSpinners3DotsBounce0.begin+0.1s"
                              calcMode="spline"
                              dur="0.6s"
                              keySplines=".33,.66,.66,1;.33,0,.66,.33"
                              values="12;6;12"
                            ></animate>
                          </circle>
                          <circle cx={20} cy={12} r={3} fill="currentColor">
                            <animate
                              id="svgSpinners3DotsBounce1"
                              attributeName="cy"
                              begin="svgSpinners3DotsBounce0.begin+0.2s"
                              calcMode="spline"
                              dur="0.6s"
                              keySplines=".33,.66,.66,1;.33,0,.66,.33"
                              values="12;6;12"
                            ></animate>
                          </circle>
                        </svg>
                      ) : (
                        <img
                          src={theme ? sendIcon : sendIconLight}
                          alt="send"
                          width={35}
                          height={35}
                          className={`${message.trim() === "" ? "opacity-30" : ""} ${theme === "dark" ? "" : "filterGrey"}`}
                        />
                      )}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        {/*<input
          ref={fileRef}
          type="file"
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) {
              handleFileUpload(file);
            }
          }}
          style={{ display: "none" }} // Hide the file input
          accept=".pdf,.txt,.doc,.docx,.csv,.jpg,.png" // File types you want to accept
        />
        {/* <div className="w-0 h-0" ref={messagesEndRef} /> */}
        {/* Scroll to Bottom Button */}
      </div>
      {
        messages.length > 0 && chatID ? (
          <div className="flex  items-center max-w-[1200px] w-full mx-auto hide-scrollbar ">
            {/* Scroll to Bottom Button */}
            {showScrollToBottom && (
              <button
                onClick={handleScrollToBottom}
                className="cursor-pointer absolute z-10 rounded-full bg-clip-padding  text-token-text-secondary border-token-border-light right-1/2 translate-x-1/2 bg-token-main-surface-primary w-8 h-8 flex items-center justify-center bottom-36 border-none p-1.5 bg-[#00000029]"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon-md text-token-text-primary"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C11.7348 21 11.4804 20.8946 11.2929 20.7071L4.29289 13.7071C3.90237 13.3166 3.90237 12.6834 4.29289 12.2929C4.68342 11.9024 5.31658 11.9024 5.70711 12.2929L11 17.5858V4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4V17.5858L18.2929 12.2929C18.6834 11.9024 19.3166 11.9024 19.7071 12.2929C20.0976 12.6834 20.0976 13.3166 19.7071 13.7071L12.7071 20.7071C12.5196 20.8946 12.2652 21 12 21Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </button>
            )}
            <div className="w-full bg-white/30 brightness-[0.8] dark:brightness-90 dark:bg-black/10 rounded-2xl px-5 py-2">
              <div className="w-full mb-4 ">
                <textarea
                  ref={textareaRef}
                  value={message}
                  disabled={isMessageSent}
                  onChange={(e) => setMessage(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey && message.trim() !== "") {
                      e.preventDefault(); // Prevent new line on Enter without Shift
                      sendMessage();
                    }
                  }}
                  placeholder="Ask me anything... "
                  rows={1} // Adjust number of rows as needed
                  className="w-full outline-none focus-visible:border-0 focus-visible:ring-0 ring-transparent outline-transparent border-transparent resize-none placeholder:brightness-125 dark:placeholder:text-[#5E829F] placeholder:text-[#7B7B7B] text-base focus:outline-none bg-transparent dark:text-white text-chatLightText rounded-lg py-1 overflow-y-auto"
                />
              </div>
              <div className="flex items-center w-full ">
                {/* <div className="flex items-start flex-1 gap-3">
                  <Menu>
                    <MenuButton className="">
                      <Tooltip
                        content="Attach File"
                        classNames={{
                          content: [
                            "dark:bg-[#265376]/30 bg-white backdrop-blur-[23px] rounded-lg shadow-none",
                          ],
                        }}
                      >
                        <img
                          src={addIcon}
                          alt="add"
                          width={21}
                          height={21}
                          className="invert dark:invert-0"
                        />
                      </Tooltip>
                    </MenuButton>

                    <MenuItems
                      transition
                      anchor="bottom"
                      className="w-fit origin-top-right rounded-xl border border-white/5 dark:bg-lightBg/5 bg-chatDarkBg/10 p-1 text-sm/6 text-white transition duration-100 ease-out [--anchor-gap:var(--spacing-1)] focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0"
                    >
                      <MenuItem>
                        <button
                          onClick={() => {
                            // Trigger the file input click event to open file dialog
                            fileRef.current?.click();
                          }}
                          className="text-left group flex w-full items-center gap-2 rounded-lg py-1.5 px-3 data-[focus]:bg-white/10 dark:text-lightBg text-chatLightText"
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5 shrink-0"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M18.0322 5.02393C17.7488 5.00078 17.3766 5 16.8 5H11.5002C11.3 6 11.0989 6.91141 10.8903 7.85409C10.7588 8.44955 10.6432 8.97304 10.3675 9.41399C10.1262 9.80009 9.80009 10.1262 9.41399 10.3675C8.97304 10.6432 8.44955 10.7588 7.85409 10.8903C7.81276 10.8994 7.77108 10.9086 7.72906 10.9179L5.21693 11.4762C5.1442 11.4924 5.07155 11.5001 5 11.5002V16.8C5 17.3766 5.00078 17.7488 5.02393 18.0322C5.04612 18.3038 5.0838 18.4045 5.109 18.454C5.20487 18.6422 5.35785 18.7951 5.54601 18.891C5.59546 18.9162 5.69617 18.9539 5.96784 18.9761C6.25118 18.9992 6.62345 19 7.2 19H10C10.5523 19 11 19.4477 11 20C11 20.5523 10.5523 21 10 21H7.16144C6.6343 21 6.17954 21 5.80497 20.9694C5.40963 20.9371 5.01641 20.8658 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3.13419 18.9836 3.06287 18.5904 3.03057 18.195C2.99997 17.8205 2.99998 17.3657 3 16.8385L3 11C3 8.92477 4.02755 6.93324 5.4804 5.4804C6.93324 4.02755 8.92477 3 11 3L16.8385 3C17.3657 2.99998 17.8205 2.99997 18.195 3.03057C18.5904 3.06287 18.9836 3.13419 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C20.8658 5.01641 20.9371 5.40963 20.9694 5.80497C21 6.17954 21 6.6343 21 7.16144V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V7.2C19 6.62345 18.9992 6.25118 18.9761 5.96784C18.9539 5.69617 18.9162 5.59546 18.891 5.54601C18.7951 5.35785 18.6422 5.20487 18.454 5.109C18.4045 5.0838 18.3038 5.04612 18.0322 5.02393ZM5.28014 9.41336L7.2952 8.96556C8.08861 8.78925 8.24308 8.74089 8.35381 8.67166C8.48251 8.59121 8.59121 8.48251 8.67166 8.35381C8.74089 8.24308 8.78925 8.08861 8.96556 7.2952L9.41336 5.28014C8.51014 5.59289 7.63524 6.15398 6.89461 6.89461C6.15398 7.63524 5.59289 8.51014 5.28014 9.41336ZM17 15C17 14.4477 17.4477 14 18 14C18.5523 14 19 14.4477 19 15V17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H19V21C19 21.5523 18.5523 22 18 22C17.4477 22 17 21.5523 17 21V19H15C14.4477 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17H17V15Z"
                              fill="currentColor"
                            ></path>
                          </svg>
                          Upload from computer
                        </button>
                      </MenuItem>
                    </MenuItems>
                  </Menu>
                </div> */}
                <div className="flex">
                  <button
                    onClick={sendMessage}
                    disabled={isMessageSent || message.trim().length === 0}
                    className={`relative `}
                  >
                    {isMessageSent ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={38}
                        height={38}
                        viewBox="0 0 24 24"
                        className="!duration-0 transition-none brightness-150"
                      >
                        <circle cx={4} cy={12} r={3} fill="currentColor">
                          <animate
                            id="svgSpinners3DotsBounce0"
                            attributeName="cy"
                            begin="0;svgSpinners3DotsBounce1.end+0.25s"
                            calcMode="spline"
                            dur="0.6s"
                            keySplines=".33,.66,.66,1;.33,0,.66,.33"
                            values="12;6;12"
                          ></animate>
                        </circle>
                        <circle cx={12} cy={12} r={3} fill="currentColor">
                          <animate
                            attributeName="cy"
                            begin="svgSpinners3DotsBounce0.begin+0.1s"
                            calcMode="spline"
                            dur="0.6s"
                            keySplines=".33,.66,.66,1;.33,0,.66,.33"
                            values="12;6;12"
                          ></animate>
                        </circle>
                        <circle cx={20} cy={12} r={3} fill="currentColor">
                          <animate
                            id="svgSpinners3DotsBounce1"
                            attributeName="cy"
                            begin="svgSpinners3DotsBounce0.begin+0.2s"
                            calcMode="spline"
                            dur="0.6s"
                            keySplines=".33,.66,.66,1;.33,0,.66,.33"
                            values="12;6;12"
                          ></animate>
                        </circle>
                      </svg>
                    ) : (
                      <img
                        src={theme ? sendIcon : sendIconLight}
                        alt="send"
                        width={35}
                        height={35}
                        className={`${message.trim().length > 0 ? "opacity-100" : "opacity-30"} ${theme === "dark" ? "" : "filterGrey"}`}
                      />
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )
      }
      <ModalManager />
    </div >
  );
};

export default ChatWindow;
